package com.heelion.farmafreelance.utils

import kotlin.math.max
import kotlin.math.round

/**
 * Stima dell'imposta per il regime forfettario, usata da "I miei guadagni", da Farmy e
 * dall'export per il commercialista. È indicativa: il commercialista fa il calcolo vero.
 *
 * Imponibile = lordo × coefficiente di redditività (78% per le attività professionali, compresi
 * i farmacisti) − contributi previdenziali (qui l'ENPAF stimato); imposta sostitutiva = imponibile ×
 * aliquota (15%, oppure 5% nei primi 5 anni di attività). Col regime ordinario non si stima nulla:
 * l'IRPEF dipende dagli altri redditi e dalle detrazioni.
 */
object StimaFiscale {
    const val COEFFICIENTE_REDDITIVITA = 0.78
    const val ALIQUOTA_ORDINARIA_FORFETTARIO = 15.0
    const val ALIQUOTA_STARTUP_FORFETTARIO = 5.0

    fun eForfettario(regimeFiscale: String?): Boolean = regimeFiscale?.contains("forfett", ignoreCase = true) == true

    /** Aliquota da usare (es. 15.0), o null se il regime non è forfettario e l'imposta non si stima. */
    fun aliquota(regimeFiscale: String?, aliquotaForfettario: Double): Double? =
        if (eForfettario(regimeFiscale)) aliquotaForfettario else null

    /** Imposta sostitutiva stimata su [lordo], con [contributi] deducibili (ENPAF). */
    fun imposta(lordo: Double, contributi: Double, aliquota: Double): Double {
        val imponibile = max(0.0, lordo * COEFFICIENTE_REDDITIVITA - contributi)
        return round(imponibile * aliquota) / 100
    }
}
